import { render, staticRenderFns } from "./BlockedUsersTable.vue?vue&type=template&id=5a2534c0"
import script from "./BlockedUsersTable.vue?vue&type=script&lang=js"
export * from "./BlockedUsersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports